const bestActions = {
  leadership: {
    title:
      "Aujourd’hui, prenez 5 min en réunion pour exposer à nouveau <b>le sens et la finalité du projet</b> sur lequel vous travaillez, ainsi que la mission que s’est donnée l'entreprise, pour remotiver les troupes.",
    action: "5b967031030fd9002244d992",
    rating: 4.8,
    isFake: true,
    donePercentage: 100,
    count: 31
  },
  resilience: {
    count: 54,
    action: "5b967033030fd9002244d9a1",
    rating: 4.86,
    isFake: true,
    donePercentage: 100,
    title:
      "Aujourd'hui, les contraintes et les difficultés sont transformées en opportunités. Ecris sur un carnet <b>chaque difficulté/contrainte </b>que tu rencontres et écris en face de celle-ci ”<b>c'est l'opportunité pour moi de …</b>“"
  },
  proactivity: {
    count: 37,
    action: "5b967034030fd9002244d9a5",
    rating: 4.6,
    isFake: true,
    donePercentage: 100,
    title:
      "Aujourd'hui, demandez à un membre de votre équipe ce qu'il aime dans votre travail et <b>comment vous pouvez vous améliorer.</b><br><br><i>Au niveau de votre façon d'agir, de votre organisation ou de votre communication.</i>"
  },
  publicSpeaking: {
    count: 33,
    action: "5b967034030fd9002244d9a4",
    rating: 4.7,
    isFake: true,
    donePercentage: 100,
    title:
      "À chaque fois que tu illustres ton propos avec un exemple, essaye de le <b>personnaliser le plus possible à la personne qui se trouve en face de toi :</b> en utilisant son prénom et son histoire."
  },
  teamCohesion: {
    count: 23,
    action: "5b967034030fd9002244d9a3",
    rating: 4.45,
    isFake: true,
    donePercentage: 100,
    title:
      "Aujourd'hui, <b>prendre 15 min de son temps pour communiquer ou faire partager un apprentissage</b>, une bonne pratique, un retour d’expérience qui peut servir à 1 ou plusieurs collaborateurs par l’envoie d’un email. "
  }
};

export default {
  totalDoneActions: 428,
  totalActionsViews: 631,
  totalOneGoodRate: 102,
  logo: "https://cdn-group.bnpparibas.com/bundles/app/img/logo-bnp.svg",
  email: "clement.dutartre@gmail.com",
  dashboardAccess: ["clement.dutartre@gmail.com"],
  createdAt: "2018-09-17T12:40:43.592Z",
  name: "Bnp Paribas",
  totalEmployees: 112,
  comments: [
    "En mettant en place ce défi, j’ai la sensation d’avoir impliqué davantage mon équipe",
    "Cela m’a permit d’évacuer une partie du stress inconsciemment",
    "Mindset plus positif pour la suite de la semaine",
    "Ça permet de prendre du recul pour bien réfléchir aux arguments et bien les formuler"
  ],
  bestActions,
  teamRanking: [
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-mediator.png",
      name: "Acacia",
      experience: 23,
      rank: 1
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-advocate.png",
      name: "Epicéa",
      experience: 19,
      rank: 2
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-commandant.png",
      name: "Europe",
      experience: 15,
      rank: 3
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/5ba125f2cc23c50022dafae6-Mon Oct 15 2018 11:50:26 GMT-0700 (PDT)",
      experience: 13,
      name: "Argousier",
      rank: 4
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-innovateur.png",
      name: "Pacanier",
      experience: 13,
      rank: 5
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-mediator.png",
      name: "Arbre de soie",
      experience: 9
    },
    {
      picture: "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-penseur.png",
      name: "Parasolier",
      experience: 8,
      rank: 5
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-protagonist.png",
      name: "Aralia de Californie",
      experience: 6,
      rank: 4
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-scientifique.png",
      name: "Nerprun",
      experience: 4,
      rank: 2
    },
    {
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-advocate.png",
      name: "Citron",
      experience: 3,
      rank: 10
    }
  ],
  userRanking: [
    {
      _id: "5b9fe4a98860b0002293e5b9",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-advocate.png",
      firstName: "Cyrille",
      lastName: "Boullier",
      experience: 43,
      rank: 1
    },
    {
      _id: "5b9fbe7b8860b0002293e5a3",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-scientifique.png",
      firstName: "Johanna ",
      lastName: "Nakache",
      experience: 39,
      rank: 1
    },
    {
      _id: "5bc4971a4bd7b20022bf1278",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-protagonist.png",
      firstName: "David",
      lastName: "De Groeve",
      experience: 24,
      rank: 1
    },
    {
      _id: "5ba125f2cc23c50022dafae6",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/5ba125f2cc23c50022dafae6-Mon Oct 15 2018 11:50:26 GMT-0700 (PDT)",
      firstName: "Bruno",
      lastName: "Tallard",
      experience: 20,
      fullName: "Roger gustav",
      rank: 4
    },
    {
      _id: "5baaa7cfcfcbf0001cfc7b6b",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-mediator.png",
      firstName: "Valérie",
      lastName: "De araujo",
      experience: 15,
      rank: 5
    },
    {
      _id: "5baa09bdcbd38b008478a245",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-advocate.png",
      firstName: "Johann",
      lastName: "Apfeldorfer",
      experience: 14
    },
    {
      _id: "5bd858160af6ae0097aaa3a0",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-mediator.png",
      firstName: "Véronique",
      lastName: "Grenouillet",
      experience: 14,
      rank: 5
    },
    {
      _id: "5bbe3563aacbc1001fa797b7",
      picture: "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-penseur.png",
      firstName: "Andrew",
      lastName: "Higgins",
      experience: 13,
      rank: 4
    },
    {
      _id: "5bb3f38d5214ca001eedc327",
      picture:
        "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-mediator.png",
      firstName: "Shany",
      lastName: "Venon",
      experience: 13,
      rank: 2
    },
    {
      _id: "5bb6867691f4930085e36efa",
      picture: "https://s3.eu-west-3.amazonaws.com/liife-db/AVATAR-penseur.png",
      firstName: "Roberto",
      lastName: "Etuvio",
      experience: 11,
      rank: 10
    }
  ],
  feelingEvolution: [
    {
      mois: "octobre",
      monthNumber: 9,
      users: 10,
      Stress: 0.1,
      Confiance: 0.65,
      "Aisance à l'oral": 0.1,
      "Cohésion d'équipe": 0.3,
      Productivité: 0.1
    },
    {
      mois: "novembre",
      monthNumber: 10,
      users: 10,
      Stress: -0.1,
      Confiance: 0.4,
      "Aisance à l'oral": -0.4,
      "Cohésion d'équipe": 0.2,
      Productivité: 0.5
    },
    {
      mois: "décembre",
      monthNumber: 11,
      users: 14,
      Stress: 0.14285714285714285,
      Confiance: 0.7857142857142857,
      "Aisance à l'oral": 0.5,
      "Cohésion d'équipe": 0.35714285714285715,
      Productivité: 0.7142857142857143
    }
  ],
  firstFeeling: [
    { title: "Stress", "Situation initiale": 3.23, Objectif: 8 },
    { title: "Confiance", "Situation initiale": 5.52, Objectif: 7.5 },
    { title: "Cohésion d'équipe", "Situation initiale": 4.25, Objectif: 9 },
    { title: "Aisance à l'oral", "Situation initiale": 6.4, Objectif: 8.3 }
  ],
  repartitionByCategory: [
    {
      color: "rgba(252,87,122,0.8)",
      id: "Leadership",
      label: "Leadership",
      value: 195
    },
    {
      color: "rgba(66,80,251,0.8)",
      id: "Capacité à convaincre",
      label: "Capacité à convaincre",
      value: 35
    },
    {
      color: "rgba(0,170,255,0.8)",
      id: "Pro-activité",
      label: "Pro-activité",
      value: 72
    },
    {
      color: "#FF9F40",
      id: "Cohésion d'Équipe",
      label: "Cohésion d'Équipe",
      value: 44
    },
    {
      color: "#FFC233",
      id: "Résilience",
      label: "Résilience",
      value: 83
    }
  ],
  repartitionByFunction: [
    { id: "Finance", label: "Finance", value: 6, color: "#0c056d" },
    { id: "Sales", label: "Sales", value: 4, color: "#590d82" },
    { id: "Marketing", label: "Marketing", value: 15, color: "#b61aae" },
    { id: "IT", label: "IT", value: 24, color: "#f25d9c" },
    { id: "Autre", label: "Autre", value: 24, color: "#6b76ff" }
  ],
  weeklyActions: [
    { actions: 0 },
    { actions: 34, week: 38, date: "17 septembre" },
    { actions: 77, week: 39, date: "24 septembre" },
    { actions: 143, week: 40, date: "1 octobre" },
    { actions: 176, week: 41, date: "8 octobre" },
    { actions: 210, week: 42, date: "15 octobre" },
    { actions: 218, week: 43, date: "22 octobre" },
    { actions: 251, week: 44, date: "29 octobre" },
    { actions: 257, week: 45, date: "5 novembre" },
    { actions: 279, week: 46, date: "12 novembre" },
    { actions: 344, week: 48, date: "26 novembre" },
    { actions: 419, week: 49, date: "3 décembre" },
    { actions: 429, week: 50, date: "10 décembre" }
  ],
  allActions: [
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5ba26dffcc23c50022dafb69",
      date: "2018-09-19T15:40:47.851Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5ba142e2cc23c50022dafb02",
      date: "2018-09-18T18:24:34.857Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5ba240c7cc23c50022dafb2d",
      date: "2018-09-19T12:27:51.699Z",
      comment: "C'est l'opportunité pour moi de progresser !",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5ba2422fcc23c50022dafb32",
      date: "2018-09-19T12:33:51.754Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5ba25560cc23c50022dafb3a",
      date: "2018-09-19T13:55:44.684Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5ba2599d0b8523039407280b",
      date: "2018-09-19T14:13:49.287Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5ba25a280b8523039407281b",
      date: "2018-09-19T14:16:08.476Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5ba25a3b0b8523039407281e",
      date: "2018-09-19T14:16:27.388Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5b9fc1278860b0002293e5a7",
      date: "2018-09-17T14:58:47.372Z",
      comment: "Superbe",
      rating: 4,
      donePercentage: 75
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bbf220498bbd000243d68b8",
      date: "2018-10-11T10:12:20.519Z"
    },
    {
      action: "5b967032030fd9002244d995",
      category: "leadership",
      _id: "5bbf377c98bbd000243d68de",
      date: "2018-10-11T11:43:56.390Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bbf514a98bbd000243d68f0",
      date: "2018-10-11T13:34:02.617Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5c053627fd7dcc001cd50ffb",
      date: "2018-12-03T13:56:55.357Z",
      comment: "Oki",
      donePercentage: 75,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5c095afd1ca01301cc6e7644",
      date: "2018-12-06T17:23:09.725Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5ba12659cc23c50022dafaf0",
      date: "2018-09-18T16:22:49.840Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5ba130f8cc23c50022dafaf8",
      date: "2018-09-18T17:08:08.668Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5ba0a8b4cc23c50022dafa7a",
      date: "2018-09-18T07:26:44.617Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5ba0a8d7cc23c50022dafa7d",
      date: "2018-09-18T07:27:19.893Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5bbf321c98bbd000243d68d8",
      date: "2018-10-11T11:21:00.900Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bbf366998bbd000243d68db",
      date: "2018-10-11T11:39:21.534Z",
      comment: "Jl",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bbf49b598bbd000243d68e1",
      date: "2018-10-11T13:01:41.675Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bbf4b4b98bbd000243d68e4",
      date: "2018-10-11T13:08:27.855Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bbf4df098bbd000243d68e7",
      date: "2018-10-11T13:19:44.415Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bbf4f1498bbd000243d68ea",
      date: "2018-10-11T13:24:36.939Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bbf50d798bbd000243d68ed",
      date: "2018-10-11T13:32:07.872Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5bbf567598bbd000243d68f3",
      date: "2018-10-11T13:56:05.939Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bbf58bd98bbd000243d68f9",
      date: "2018-10-11T14:05:49.893Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5c095a901ca01301cc6e763f",
      date: "2018-12-06T17:21:20.113Z",
      comment: "Fsd",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bbf577398bbd000243d68f6",
      date: "2018-10-11T14:00:19.978Z",
      comment: "Niceon",
      donePercentage: 50,
      rating: 3
    },
    {
      action: "5b967032030fd9002244d995",
      category: "leadership",
      _id: "5bd710d8f77427001cb4665d",
      date: "2018-10-29T13:53:28.973Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bd712a0f77427001cb4665f",
      date: "2018-10-29T14:01:04.129Z"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bd71785edbb600029fc42b3",
      date: "2018-10-29T14:21:57.442Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bec8c9f56177600486d1704",
      date: "2018-11-14T20:59:11.770Z"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bec8d07d5db9c001db432b8",
      date: "2018-11-14T21:00:55.594Z"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bed72cc25fa790023e97252",
      date: "2018-11-15T13:21:16.880Z"
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5bed730b25fa790023e97254",
      date: "2018-11-15T13:22:19.466Z"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5bed732c25fa790023e97256",
      date: "2018-11-15T13:22:52.190Z"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bed740125fa790023e97258",
      date: "2018-11-15T13:26:25.615Z"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bed741625fa790023e9725a",
      date: "2018-11-15T13:26:46.569Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bed743725fa790023e9725c",
      date: "2018-11-15T13:27:19.306Z"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5c0155710347710023f608a4",
      date: "2018-11-30T15:21:21.882Z"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5c015ad90347710023f608a6",
      date: "2018-11-30T15:44:25.713Z"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5c0299f9a65525001c58f859",
      date: "2018-12-01T14:26:01.039Z"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5c029d7aa65525001c58f85b",
      date: "2018-12-01T14:40:58.227Z"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5ba0c92ecc23c50022dafac5",
      date: "2018-09-18T09:45:18.436Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5ba8e7163abc06002a28875f",
      date: "2018-09-24T13:31:02.975Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bb1eb6aabe104001fb29078",
      date: "2018-10-01T09:39:54.395Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99e",
      category: "leadership",
      _id: "5c02b37c144b00005d610f25",
      date: "2018-12-01T16:14:52.156Z",
      comment: "Niceon",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5c02b503144b00005d610f28",
      date: "2018-12-01T16:21:23.287Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5c09597e87c5ef01bf56244c",
      date: "2018-12-06T17:16:46.934Z",
      comment: "He",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c095a471ca01301cc6e7632",
      date: "2018-12-06T17:20:07.405Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "publicSpeaking",
      _id: "5c095a5d1ca01301cc6e7637",
      date: "2018-12-06T17:20:29.083Z",
      comment: "Oke",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5c095a771ca01301cc6e763b",
      date: "2018-12-06T17:20:55.582Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "publicSpeaking",
      _id: "5c095aa81ca01301cc6e7641",
      date: "2018-12-06T17:21:44.163Z",
      comment: "Oki",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5c095b121ca01301cc6e7648",
      date: "2018-12-06T17:23:30.268Z",
      comment: "Tp",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5ba0a8e1cc23c50022dafa80",
      date: "2018-09-18T07:27:29.644Z",
      comment: "Nice",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5b9fe6058860b0002293e5bc",
      date: "2018-09-17T17:36:05.397Z",
      comment: "",
      rating: 1,
      donePercentage: 0
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5ba8e7053abc06002a28875c",
      date: "2018-09-24T13:30:45.751Z",
      comment: "",
      donePercentage: 0,
      rating: 1
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5ba9646b299d89001cb71418",
      date: "2018-09-24T22:25:47.018Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb1ee73abe104001fb2907b",
      date: "2018-10-01T09:52:51.330Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb22123195d6700699eb5f7",
      date: "2018-10-01T13:29:07.152Z"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bbf8b3da3f72e01039229db",
      date: "2018-10-11T17:41:17.948Z"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bd72bc357220500361f4b11",
      date: "2018-10-29T15:48:19.745Z"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bd72c6857220500361f4b13",
      date: "2018-10-29T15:51:04.616Z"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bd72d0a57220500361f4b15",
      date: "2018-10-29T15:53:46.401Z"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bd730fa57220500361f4b17",
      date: "2018-10-29T16:10:34.604Z"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bd7877c635bd400fc2af13b",
      date: "2018-10-29T22:19:40.062Z"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5bfe9ee25ac159005abe615a",
      date: "2018-11-28T13:57:54.038Z"
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5bfe9f435ac159005abe615c",
      date: "2018-11-28T13:59:31.702Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bfe9f5c5ac159005abe615e",
      date: "2018-11-28T13:59:56.025Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bfea1f35ac159005abe6160",
      date: "2018-11-28T14:10:59.972Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bfec265f9d10e001c66ef90",
      date: "2018-11-28T16:29:25.076Z"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5c095146649dcc018792a76c",
      date: "2018-12-06T16:41:42.621Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c096ff6a3461c002244d1ed",
      date: "2018-12-06T18:52:38.931Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bfec293f9d10e001c66ef92",
      date: "2018-11-28T16:30:11.067Z",
      comment: "Oki",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c0298cca65525001c58f848",
      date: "2018-12-01T14:21:00.706Z"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5ba24110cc23c50022dafb30",
      date: "2018-09-19T12:29:04.639Z",
      comment: "",
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5ba621f0a00a5500226a9435",
      date: "2018-09-22T11:05:20.903Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5ba80bb403087d002ac8a27f",
      date: "2018-09-23T21:55:00.574Z",
      comment: "At top",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5ba80bc103087d002ac8a282",
      date: "2018-09-23T21:55:13.900Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5ba80dd803087d002ac8a285",
      date: "2018-09-23T22:04:08.633Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5ba2562ecc23c50022dafb42",
      date: "2018-09-19T13:59:10.694Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5ba25f2acc23c50022dafb4f",
      date: "2018-09-19T14:37:30.274Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5ba80ef403087d002ac8a29b",
      date: "2018-09-23T22:08:52.840Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c0298e7a65525001c58f84a",
      date: "2018-12-01T14:21:27.715Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5c0298fda65525001c58f84d",
      date: "2018-12-01T14:21:49.937Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5c029921a65525001c58f850",
      date: "2018-12-01T14:22:25.622Z",
      comment: "Oki",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99e",
      category: "leadership",
      _id: "5c0299bda65525001c58f853",
      date: "2018-12-01T14:25:01.177Z",
      comment: "D’accord!",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5c053073f58614001d116d3d",
      date: "2018-12-03T13:32:35.717Z",
      comment: "AU TOP",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d995",
      category: "leadership",
      _id: "5c07a91280817a001d5eacbc",
      date: "2018-12-05T10:31:46.086Z",
      comment: "Super",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5c095038649dcc018792a75f",
      date: "2018-12-06T16:37:12.410Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5c095086649dcc018792a763",
      date: "2018-12-06T16:38:30.494Z",
      comment: "Nice",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5c0950e6649dcc018792a767",
      date: "2018-12-06T16:40:06.053Z",
      comment: "He",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5c09578587c5ef01bf562425",
      date: "2018-12-06T17:08:21.018Z",
      comment: "Nice",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5c09582087c5ef01bf562429",
      date: "2018-12-06T17:10:56.590Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5c09586087c5ef01bf56242b",
      date: "2018-12-06T17:12:00.340Z",
      comment: "Parfait",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5c0ad52bcd2b9f0022a2ed21",
      date: "2018-12-07T20:16:43.686Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967030030fd9002244d990",
      category: "proactivity",
      _id: "5c13d1673fcd4000c2009e06",
      date: "2018-12-14T15:51:03.978Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5c1520cac5edf5002361567c",
      date: "2018-12-15T15:42:02.246Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c152172c5edf5002361567f",
      date: "2018-12-15T15:44:50.504Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c1521d6c5edf50023615681",
      date: "2018-12-15T15:46:30.981Z",
      comment: "Oki",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c152223c5edf50023615683",
      date: "2018-12-15T15:47:47.739Z",
      comment: "Nice",
      donePercentage: 100,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5c152247c5edf50023615685",
      date: "2018-12-15T15:48:23.572Z",
      comment: "Superbe",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5c1522cbc5edf50023615687",
      date: "2018-12-15T15:50:35.911Z",
      comment: "Super",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5c1526aec5edf50023615689",
      date: "2018-12-15T16:07:10.697Z",
      comment: "Super",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5ba0a4e08860b0002293e5db",
      date: "2018-09-18T07:10:24.300Z",
      comment: "",
      rating: 1,
      donePercentage: 25
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5ba33ee0cc23c50022dafb74",
      date: "2018-09-20T06:32:00.682Z"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5ba25edbcc23c50022dafb4d",
      date: "2018-09-19T14:36:11.219Z"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5ba80efd03087d002ac8a29e",
      date: "2018-09-23T22:09:01.779Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5ba91863cbc7af0085ef502f",
      date: "2018-09-24T17:01:23.706Z",
      comment: " Nice one",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5ba91b49cbc7af0085ef5032",
      date: "2018-09-24T17:13:45.250Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5ba91bd0cbc7af0085ef5035",
      date: "2018-09-24T17:16:00.297Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5ba94eb5cbc7af0085ef5038",
      date: "2018-09-24T20:53:09.623Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5ba94f13cbc7af0085ef503b",
      date: "2018-09-24T20:54:43.092Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5ba9502ccbc7af0085ef503e",
      date: "2018-09-24T20:59:24.202Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5ba95074cbc7af0085ef5041",
      date: "2018-09-24T21:00:36.067Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5c093ffe93a68500ef2901ff",
      date: "2018-12-06T15:27:58.018Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5baa682513956b003278458f",
      date: "2018-09-25T16:53:57.478Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5baa68eb13956b0032784595",
      date: "2018-09-25T16:57:15.146Z",
      comment: "Nice one",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5baaa846cfcbf0001cfc7b6f",
      date: "2018-09-25T21:27:34.978Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5baaa8f0cfcbf0001cfc7b72",
      date: "2018-09-25T21:30:24.086Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bb5e89597e101001fc4e315",
      date: "2018-10-04T10:16:53.947Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb5e95214f318001e2af085",
      date: "2018-10-04T10:20:02.677Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bb5e9d0010566001ead577f",
      date: "2018-10-04T10:22:08.581Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5bb5ee39010566001ead5788",
      date: "2018-10-04T10:40:57.481Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5c0ac468cd2b9f0022a2ed1a",
      date: "2018-12-07T19:05:12.517Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5baa66a9d667ff001c6a7785",
      date: "2018-09-25T16:47:37.297Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5baaa506cfcbf0001cfc7b68",
      date: "2018-09-25T21:13:42.765Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb261ece2ac1601543cc2ce",
      date: "2018-10-01T18:05:32.084Z",
      comment: "Nice one",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bb398e157cf860024c7723d",
      date: "2018-10-02T16:12:17.977Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bb5fc4d4e3126001e5b2a27",
      date: "2018-10-04T11:41:01.726Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb5fd662f641e0034965981",
      date: "2018-10-04T11:45:42.639Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bbdcc77512c07001ed887e6",
      date: "2018-10-10T09:55:03.352Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bbdd063512c07001ed887e9",
      date: "2018-10-10T10:11:47.001Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bbdd5db2bdead001e9b7f56",
      date: "2018-10-10T10:35:07.647Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bd895dc46d186001c195d55",
      date: "2018-10-30T17:33:16.432Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5bb3a834b1171b005affd78d",
      date: "2018-10-02T17:17:40.211Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bb3af4759b1a8008da8f149",
      date: "2018-10-02T17:47:51.752Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb3f3575214ca001eedc321",
      date: "2018-10-02T22:38:15.743Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5bb3f36b5214ca001eedc324",
      date: "2018-10-02T22:38:35.064Z",
      comment: "",
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bc99abb8930e100b050c5c3",
      date: "2018-10-19T08:50:03.689Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5c082863e275fe001ca856e0",
      date: "2018-12-05T19:34:59.962Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c092d73e275fe001ca856e4",
      date: "2018-12-06T14:08:51.035Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5c093e8793a68500ef2901fd",
      date: "2018-12-06T15:21:43.044Z",
      comment: "Super be job",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c09402593a68500ef290202",
      date: "2018-12-06T15:28:37.057Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5baa68cc13956b0032784593",
      date: "2018-09-25T16:56:44.008Z"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5bb5e87997e101001fc4e313",
      date: "2018-10-04T10:16:25.882Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb5e9b3010566001ead5779",
      date: "2018-10-04T10:21:39.445Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bb5e9c1010566001ead577c",
      date: "2018-10-04T10:21:53.978Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bb67ecf91f4930085e36ef0",
      date: "2018-10-04T20:57:51.560Z",
      comment: "Superbe",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5c02b145144b00005d610f21",
      date: "2018-12-01T16:05:25.809Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c02b621144b00005d610f2d",
      date: "2018-12-01T16:26:09.085Z"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5c0540b22d0c40003f5a7482",
      date: "2018-12-03T14:41:54.995Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb2620ce2ac1601543cc2d1",
      date: "2018-10-01T18:06:04.334Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5c0ace4acd2b9f0022a2ed1c",
      date: "2018-12-07T19:47:22.468Z",
      comment: "L",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5c0ac1e0cd2b9f0022a2ed16",
      date: "2018-12-07T18:54:24.635Z",
      comment: "Top",
      donePercentage: 75,
      rating: 3
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bb5fc704e3126001e5b2a2b",
      date: "2018-10-04T11:41:36.042Z"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bb5fd132f641e003496597d",
      date: "2018-10-04T11:44:19.962Z"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5bb3af2a59b1a8008da8f147",
      date: "2018-10-02T17:47:22.688Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bc4cc2acf6da5001d435dae",
      date: "2018-10-15T17:19:38.016Z"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bc4e03893f181001c7bba60",
      date: "2018-10-15T18:45:12.174Z"
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5bc9989c8930e100b050c5c1",
      date: "2018-10-19T08:41:00.411Z"
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bd718cdedbb600029fc42b7",
      date: "2018-10-29T14:27:25.401Z"
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bd745fe5c4db4009a653421",
      date: "2018-10-29T17:40:14.008Z"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5bd746c65c4db4009a653423",
      date: "2018-10-29T17:43:34.852Z"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bd74f4e5c4db4009a653425",
      date: "2018-10-29T18:19:58.244Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bd88efb46d186001c195d3f",
      date: "2018-10-30T17:03:55.779Z",
      comment: "Super",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bd892a546d186001c195d45",
      date: "2018-10-30T17:19:33.236Z",
      comment: "Ok",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bd8942b46d186001c195d4c",
      date: "2018-10-30T17:26:03.550Z",
      comment: "Au top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c053779fd7dcc001cd51000",
      date: "2018-12-03T14:02:33.558Z"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5c0539ebad4bb0001c57b9f6",
      date: "2018-12-03T14:12:59.552Z",
      comment: "Super",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5c053ef6bd7dca0029dd0420",
      date: "2018-12-03T14:34:30.130Z"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5c053f95bd7dca0029dd0422",
      date: "2018-12-03T14:37:09.920Z"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bb22e464ec5e200e37e124a",
      date: "2018-10-01T14:25:10.134Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bb22e664ec5e200e37e124d",
      date: "2018-10-01T14:25:42.779Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb22e754ec5e200e37e1250",
      date: "2018-10-01T14:25:57.739Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb6809791f4930085e36ef4",
      date: "2018-10-04T21:05:27.313Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb680b891f4930085e36ef6",
      date: "2018-10-04T21:06:00.547Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c05418c2d0c40003f5a748a",
      date: "2018-12-03T14:45:32.126Z"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bb3f3c75214ca001eedc32b",
      date: "2018-10-02T22:40:07.234Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bb3f4275214ca001eedc330",
      date: "2018-10-02T22:41:43.338Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb3f4395214ca001eedc332",
      date: "2018-10-02T22:42:01.322Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5bb3f44a5214ca001eedc335",
      date: "2018-10-02T22:42:18.232Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bb3f4565214ca001eedc338",
      date: "2018-10-02T22:42:30.472Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb5d52219f153001e2d04d9",
      date: "2018-10-04T08:53:54.466Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bb5d5b219f153001e2d04dc",
      date: "2018-10-04T08:56:18.149Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bb5d75cd9036d0020872888",
      date: "2018-10-04T09:03:24.147Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bb5e2302d43ba008329003c",
      date: "2018-10-04T09:49:36.765Z",
      comment: "Nice one",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bb5e2312d43ba008329003e",
      date: "2018-10-04T09:49:37.742Z"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bb5e2b12d43ba0083290041",
      date: "2018-10-04T09:51:45.436Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5bb5e3152d43ba0083290044",
      date: "2018-10-04T09:53:25.776Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5bb5e4572d43ba0083290047",
      date: "2018-10-04T09:58:47.644Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5be4b0934d2f30001c8c5e15",
      date: "2018-11-08T21:54:27.346Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "finance"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb687af91f4930085e36f02",
      date: "2018-10-04T21:35:43.438Z",
      comment: "Nice one !",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bb6885191f4930085e36f05",
      date: "2018-10-04T21:38:25.873Z",
      comment: "Nice one",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bb6886691f4930085e36f08",
      date: "2018-10-04T21:38:46.987Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb688e291f4930085e36f0f",
      date: "2018-10-04T21:40:50.172Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bc993df0f833e00a300dcf6",
      date: "2018-10-19T08:20:47.624Z",
      comment: "Kl",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Finance"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bc996408930e100b050c5be",
      date: "2018-10-19T08:30:56.268Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Finance"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5be025f24647af001c05761e",
      date: "2018-11-05T11:13:54.988Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bed766b25fa790023e97262",
      date: "2018-11-15T13:36:43.298Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "other"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bb686f491f4930085e36eff",
      date: "2018-10-04T21:32:36.816Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bb6889c91f4930085e36f0d",
      date: "2018-10-04T21:39:40.180Z"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5c056e833d5cea0048e7f63f",
      date: "2018-12-03T17:57:23.154Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5c05724ed231a0006f98f59c",
      date: "2018-12-03T18:13:34.595Z"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5c05738b1e20a7007cf77191",
      date: "2018-12-03T18:18:51.416Z"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5c0574a078687600965f6aaa",
      date: "2018-12-03T18:23:28.497Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c057512d046fa00a38a5e6d",
      date: "2018-12-03T18:25:22.441Z",
      comment: "Super",
      donePercentage: 75,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bbdd7662bdead001e9b7f5e",
      date: "2018-10-10T10:41:42.399Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bbf721dd3b8420039f3e2f2",
      date: "2018-10-11T15:54:05.902Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Sales"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bc970aa0f833e00a300dcf0",
      date: "2018-10-19T05:50:34.928Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Finance"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bc98dfa0f833e00a300dcf3",
      date: "2018-10-19T07:55:38.892Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Finance"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bc996168930e100b050c5bb",
      date: "2018-10-19T08:30:14.300Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Finance"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bed768125fa790023e97265",
      date: "2018-11-15T13:37:05.956Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "other"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bed769125fa790023e97268",
      date: "2018-11-15T13:37:21.522Z",
      comment: "",
      donePercentage: 75,
      rating: 4,
      jobFunction: "other"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bfea2ce5ac159005abe6166",
      date: "2018-11-28T14:14:38.894Z",
      jobFunction: "sales"
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bfea33d5ac159005abe6168",
      date: "2018-11-28T14:16:29.995Z",
      comment: "",
      donePercentage: 0,
      rating: 1,
      jobFunction: "sales"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bfea38b5ac159005abe616b",
      date: "2018-11-28T14:17:47.982Z",
      jobFunction: "sales"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5bfea4655ac159005abe6170",
      date: "2018-11-28T14:21:25.179Z",
      comment: "Nice one test",
      donePercentage: 0,
      rating: 5,
      jobFunction: "sales"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bffda91c9fe9200c609b9bb",
      date: "2018-11-29T12:24:49.130Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "marketing"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bffdaabc9fe9200c609b9be",
      date: "2018-11-29T12:25:15.380Z",
      comment: "Hk",
      donePercentage: 100,
      rating: 5,
      jobFunction: "marketing"
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5bffdac5c9fe9200c609b9c1",
      date: "2018-11-29T12:25:41.355Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d99e",
      category: "leadership",
      _id: "5bffdae1c9fe9200c609b9c4",
      date: "2018-11-29T12:26:09.567Z",
      comment: "Hello",
      donePercentage: 100,
      rating: 5,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d99e",
      category: "leadership",
      _id: "5c094abc649dcc018792a72d",
      date: "2018-12-06T16:13:48.821Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c094ce7649dcc018792a742",
      date: "2018-12-06T16:23:03.782Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "finance"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5c094d54649dcc018792a747",
      date: "2018-12-06T16:24:52.720Z",
      comment: "Il a vraiment apprecie",
      donePercentage: 100,
      rating: 5,
      jobFunction: "finance"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5c094e5f649dcc018792a74b",
      date: "2018-12-06T16:29:19.342Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "finance"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5c0ad5c0cd2b9f0022a2ed2a",
      date: "2018-12-07T20:19:12.570Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "finance"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5c0958a487c5ef01bf562434",
      date: "2018-12-06T17:13:08.654Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5baaa3a9cfcbf0001cfc7b5e",
      date: "2018-09-25T21:07:53.817Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5baaa4c9cfcbf0001cfc7b61",
      date: "2018-09-25T21:12:41.225Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bb23619dabb40010aa07b44",
      date: "2018-10-01T14:58:33.127Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb23647dabb40010aa07b47",
      date: "2018-10-01T14:59:19.107Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb24989dabb40010aa07b4a",
      date: "2018-10-01T16:21:29.647Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bb24a2cdabb40010aa07b4d",
      date: "2018-10-01T16:24:12.702Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bffc2c78620da0078028315",
      date: "2018-11-29T10:43:19.574Z",
      comment: "Super be idee",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bffd7efa6acf600b9bef1ff",
      date: "2018-11-29T12:13:35.939Z",
      comment: "Huil",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5c001091c9fe9200c609b9c7",
      date: "2018-11-29T16:15:13.659Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5c001382c9fe9200c609b9ca",
      date: "2018-11-29T16:27:46.995Z",
      comment: "Sdfs",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967032030fd9002244d995",
      category: "leadership",
      _id: "5c0017b9c9fe9200c609b9d0",
      date: "2018-11-29T16:45:45.418Z",
      comment: "Ok",
      donePercentage: 100,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5c094be2649dcc018792a736",
      date: "2018-12-06T16:18:42.530Z",
      comment: "Super boulot",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5c094c98649dcc018792a73f",
      date: "2018-12-06T16:21:44.604Z",
      comment: "Genial",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c0297a8a65525001c58f842",
      date: "2018-12-01T14:16:08.649Z",
      comment: "Fsf",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5c05759ad046fa00a38a5e76",
      date: "2018-12-03T18:27:38.220Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "legal"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5c09590b87c5ef01bf562443",
      date: "2018-12-06T17:14:51.449Z",
      comment: "Nice",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5c13e5ae27dcbf001c58688d",
      date: "2018-12-14T17:17:34.281Z",
      comment: "Nice",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bffc26d8620da0078028312",
      date: "2018-11-29T10:41:49.508Z",
      comment: "Super",
      donePercentage: 50,
      rating: 3,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bfea47e5ac159005abe6173",
      date: "2018-11-28T14:21:50.903Z",
      comment: "Compliance test",
      donePercentage: 25,
      rating: 2,
      jobFunction: "sales"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bfea73d5ac159005abe6176",
      date: "2018-11-28T14:33:33.293Z",
      comment: "Nice one tst",
      donePercentage: 25,
      rating: 2,
      jobFunction: "sales"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bffc23f8620da007802830f",
      date: "2018-11-29T10:41:03.608Z",
      comment: "Kjh",
      donePercentage: 0,
      rating: 2,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bfea3bd5ac159005abe616d",
      date: "2018-11-28T14:18:37.034Z",
      comment: "Nice one test",
      donePercentage: 0,
      rating: 1,
      jobFunction: "sales"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bffc75b8620da0078028318",
      date: "2018-11-29T11:02:51.922Z",
      jobFunction: "marketing"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bffd920a6acf600b9bef202",
      date: "2018-11-29T12:18:40.285Z",
      jobFunction: "marketing"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bffd93ca6acf600b9bef204",
      date: "2018-11-29T12:19:08.651Z",
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bffd9f7c9fe9200c609b9b7",
      date: "2018-11-29T12:22:15.477Z",
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bffda64c9fe9200c609b9b9",
      date: "2018-11-29T12:24:04.957Z",
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5ba128efe89eb300399ad66a",
      date: "2018-09-18T16:33:51.288Z",
      comment: "Super boulot les gars",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5ba128fce89eb300399ad66d",
      date: "2018-09-18T16:34:04.937Z",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5ba257134d4448037ae00bdd",
      date: "2018-09-19T14:02:59.092Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bc99e518930e100b050c5d4",
      date: "2018-10-19T09:05:21.534Z"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bb5f9fe4e3126001e5b2a21",
      date: "2018-10-04T11:31:10.432Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bec01c1deb94f005e351ded",
      date: "2018-11-14T11:06:41.431Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5bec01ebdeb94f005e351df0",
      date: "2018-11-14T11:07:23.529Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bec0224deb94f005e351df3",
      date: "2018-11-14T11:08:20.595Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bd722b3edbb600029fc42bc",
      date: "2018-10-29T15:09:39.381Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ventes"
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5baa9051cfcbf0001cfc7b55",
      date: "2018-09-25T19:45:21.827Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bd86ae0aad2a7001cfe97d8",
      date: "2018-10-30T14:29:52.905Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5ba125decc23c50022dafae3",
      date: "2018-09-18T16:20:46.887Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5bb221cd195d6700699eb5fd",
      date: "2018-10-01T13:31:57.836Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bb2224b195d6700699eb600",
      date: "2018-10-01T13:34:03.620Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bb2253e1fafca008caf2066",
      date: "2018-10-01T13:46:38.545Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d995",
      category: "leadership",
      _id: "5bb2255f1fafca008caf2069",
      date: "2018-10-01T13:47:11.020Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bb225951fafca008caf206c",
      date: "2018-10-01T13:48:05.780Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bb22680a984bb00a6ee301e",
      date: "2018-10-01T13:52:00.413Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bb22698a984bb00a6ee3021",
      date: "2018-10-01T13:52:24.079Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb227165d4b3200bc942f23",
      date: "2018-10-01T13:54:30.539Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bb22f2c4ec5e200e37e125f",
      date: "2018-10-01T14:29:00.593Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb230f64ec5e200e37e1262",
      date: "2018-10-01T14:36:38.850Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bb235b5dabb40010aa07b3d",
      date: "2018-10-01T14:56:53.301Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5bb5f2d44e3126001e5b2a0f",
      date: "2018-10-04T11:00:36.484Z",
      comment: "Nice one",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bb5f4474e3126001e5b2a12",
      date: "2018-10-04T11:06:47.418Z",
      comment: "Bien joe",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bb5f4f34e3126001e5b2a15",
      date: "2018-10-04T11:09:39.241Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5ba2602dcc23c50022dafb55",
      date: "2018-09-19T14:41:49.440Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5ba26037cc23c50022dafb58",
      date: "2018-09-19T14:41:59.495Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5beb32c4d7471e0040a68cb0",
      date: "2018-11-13T20:23:32.188Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5beb32f6d7471e0040a68cb3",
      date: "2018-11-13T20:24:22.267Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5beb33a40af6db004d51fb00",
      date: "2018-11-13T20:27:16.350Z",
      comment: "",
      donePercentage: 100,
      rating: 4
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5beb34f10af6db004d51fb03",
      date: "2018-11-13T20:32:49.188Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bec009d74f0f1001c771a6c",
      date: "2018-11-14T11:01:49.369Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bec014ddeb94f005e351de7",
      date: "2018-11-14T11:04:45.634Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d995",
      category: "leadership",
      _id: "5bec0173deb94f005e351dea",
      date: "2018-11-14T11:05:23.405Z",
      comment: "",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5baa9e08cfcbf0001cfc7b59",
      date: "2018-09-25T20:43:52.198Z"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5ba2606ecc23c50022dafb5b",
      date: "2018-09-19T14:42:54.155Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5ba26094cc23c50022dafb5e",
      date: "2018-09-19T14:43:32.491Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5ba2609bcc23c50022dafb61",
      date: "2018-09-19T14:43:39.935Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bbf1eb298bbd000243d68b3",
      date: "2018-10-11T09:58:10.901Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bbf264998bbd000243d68ba",
      date: "2018-10-11T10:30:33.375Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bbf2a0598bbd000243d68bd",
      date: "2018-10-11T10:46:29.524Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c00174bc9fe9200c609b9cd",
      date: "2018-11-29T16:43:55.965Z",
      comment: "Fsd",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5c056e3d3d5cea0048e7f63a",
      date: "2018-12-03T17:56:13.102Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "legal"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5c094b2a649dcc018792a731",
      date: "2018-12-06T16:15:38.479Z",
      comment: "AU top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5c094c34649dcc018792a73b",
      date: "2018-12-06T16:20:04.424Z",
      comment: "3",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c094f0f649dcc018792a74f",
      date: "2018-12-06T16:32:15.316Z",
      comment: "Genial",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5c094f39649dcc018792a754",
      date: "2018-12-06T16:32:57.905Z",
      comment: "Hello",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5c094fbe649dcc018792a757",
      date: "2018-12-06T16:35:10.094Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5c018d730347710023f608ac",
      date: "2018-11-30T19:20:19.790Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5c05754dd046fa00a38a5e73",
      date: "2018-12-03T18:26:21.325Z",
      comment: "Great",
      donePercentage: 75,
      rating: 4,
      jobFunction: "legal"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5c0958b887c5ef01bf562439",
      date: "2018-12-06T17:13:28.582Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c0958ca87c5ef01bf56243e",
      date: "2018-12-06T17:13:46.862Z",
      comment: "§",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c0adeafcd2b9f0022a2ed36",
      date: "2018-12-07T20:57:19.053Z",
      comment: "top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "accounting"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c13e7f927dcbf001c586893",
      date: "2018-12-14T17:27:21.164Z",
      comment: "Tp",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bfdd33cc8a57f001c726034",
      date: "2018-11-27T23:29:00.226Z",
      comment: "",
      donePercentage: 100,
      rating: 4,
      jobFunction: "accounting"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5c056c443d5cea0048e7f630",
      date: "2018-12-03T17:47:48.489Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5c056d143d5cea0048e7f633",
      date: "2018-12-03T17:51:16.222Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5c0d66d51914a800afc93bfa",
      date: "2018-12-09T19:02:45.689Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bffbbec78b6330022ee6b91",
      date: "2018-11-29T10:14:04.962Z",
      comment: "Fsdf",
      donePercentage: 50,
      rating: 3,
      jobFunction: "finance"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5c0d67c8e3f13900e41d68a7",
      date: "2018-12-09T19:06:48.662Z",
      comment: "Tip top",
      donePercentage: 50,
      rating: 3
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bfea7a05ac159005abe617d",
      date: "2018-11-28T14:35:12.286Z",
      comment: "Nice one",
      donePercentage: 25,
      rating: 2,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bffbb3978b6330022ee6b8b",
      date: "2018-11-29T10:11:05.743Z",
      comment: "Sg",
      donePercentage: 0,
      rating: 2,
      jobFunction: "finance"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bffc1ba8620da0078028308",
      date: "2018-11-29T10:38:50.606Z",
      comment: "Sdf",
      donePercentage: 25,
      rating: 2,
      jobFunction: "finance"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bffb97978b6330022ee6b88",
      date: "2018-11-29T10:03:37.059Z",
      comment: "Nice",
      donePercentage: 0,
      rating: 1,
      jobFunction: "finance"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bffbbc378b6330022ee6b8e",
      date: "2018-11-29T10:13:23.777Z",
      comment: "Sdf",
      donePercentage: 0,
      rating: 1,
      jobFunction: "finance"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bffbf0078b6330022ee6b94",
      date: "2018-11-29T10:27:12.658Z",
      comment: "Fs",
      donePercentage: 0,
      rating: 1,
      jobFunction: "finance"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5c05422572cf2c0055ee39a1",
      date: "2018-12-03T14:48:05.769Z"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bbf2b3c98bbd000243d68c0",
      date: "2018-10-11T10:51:40.331Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5bbf2c4598bbd000243d68c3",
      date: "2018-10-11T10:56:05.095Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bbf2cd298bbd000243d68c6",
      date: "2018-10-11T10:58:26.483Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bbf2d1998bbd000243d68c9",
      date: "2018-10-11T10:59:37.901Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bbf2f5e98bbd000243d68cc",
      date: "2018-10-11T11:09:18.436Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bbf307e98bbd000243d68cf",
      date: "2018-10-11T11:14:06.956Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bbf310098bbd000243d68d2",
      date: "2018-10-11T11:16:16.562Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bbf318298bbd000243d68d5",
      date: "2018-10-11T11:18:26.403Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5bbf6937d3b8420039f3e2e3",
      date: "2018-10-11T15:16:07.833Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bbf69c9d3b8420039f3e2e6",
      date: "2018-10-11T15:18:33.889Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bd858d30af6ae0097aaa3a4",
      date: "2018-10-30T13:12:51.623Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bd860450af6ae0097aaa3a7",
      date: "2018-10-30T13:44:37.633Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bd860740af6ae0097aaa3aa",
      date: "2018-10-30T13:45:24.894Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bd8609a0af6ae0097aaa3ad",
      date: "2018-10-30T13:46:02.908Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bd860af0af6ae0097aaa3b0",
      date: "2018-10-30T13:46:23.526Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bd860c70af6ae0097aaa3b3",
      date: "2018-10-30T13:46:47.573Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bd860e70af6ae0097aaa3b6",
      date: "2018-10-30T13:47:19.697Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bd860fa0af6ae0097aaa3b9",
      date: "2018-10-30T13:47:38.962Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bd861100af6ae0097aaa3bc",
      date: "2018-10-30T13:48:00.649Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bd8612d0af6ae0097aaa3bf",
      date: "2018-10-30T13:48:29.630Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bd861460af6ae0097aaa3c2",
      date: "2018-10-30T13:48:54.493Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5bd861580af6ae0097aaa3c5",
      date: "2018-10-30T13:49:12.404Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5bd862050af6ae0097aaa3c8",
      date: "2018-10-30T13:52:05.359Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bd862700af6ae0097aaa3cb",
      date: "2018-10-30T13:53:52.121Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Ressources Humaines"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5be02b984647af001c057631",
      date: "2018-11-05T11:38:00.867Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: ""
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5be02c9f4647af001c057634",
      date: "2018-11-05T11:42:23.111Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: ""
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5be02ced4647af001c057637",
      date: "2018-11-05T11:43:41.037Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: ""
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5ba80e9503087d002ac8a28e",
      date: "2018-09-23T22:07:17.574Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5ba80ea603087d002ac8a291",
      date: "2018-09-23T22:07:34.190Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5ba80edc03087d002ac8a297",
      date: "2018-09-23T22:08:28.448Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5baa09d1cbd38b008478a249",
      date: "2018-09-25T10:11:29.958Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5baa09d8cbd38b008478a24c",
      date: "2018-09-25T10:11:36.837Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5baa09dfcbd38b008478a24f",
      date: "2018-09-25T10:11:43.586Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5baa09e5cbd38b008478a252",
      date: "2018-09-25T10:11:49.898Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5baa09edcbd38b008478a255",
      date: "2018-09-25T10:11:57.154Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5baa09f7cbd38b008478a258",
      date: "2018-09-25T10:12:07.485Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5baa09ffcbd38b008478a25b",
      date: "2018-09-25T10:12:15.115Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5baa0a05cbd38b008478a25e",
      date: "2018-09-25T10:12:21.902Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5baa0a23cbd38b008478a261",
      date: "2018-09-25T10:12:51.223Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5baa0a32cbd38b008478a264",
      date: "2018-09-25T10:13:06.506Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bfdcedac8a57f001c72602f",
      date: "2018-11-27T23:10:18.639Z",
      comment: "",
      donePercentage: 75,
      rating: 4,
      jobFunction: "finance"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5c081c65e275fe001ca856d5",
      date: "2018-12-05T18:43:49.306Z",
      comment: "Tp",
      donePercentage: 75,
      rating: 4,
      jobFunction: "legal"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "proactivity",
      _id: "5c097767a3461c002244d207",
      date: "2018-12-06T19:24:23.625Z",
      comment: "Nice",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5c0978aaa3461c002244d20c",
      date: "2018-12-06T19:29:46.078Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c0978e7a3461c002244d211",
      date: "2018-12-06T19:30:47.877Z",
      comment: "The",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5ba80ed103087d002ac8a294",
      date: "2018-09-23T22:08:17.577Z",
      comment: "",
      donePercentage: 100,
      rating: 4
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bfee3e675d2b5001cf4d53c",
      date: "2018-11-28T18:52:22.335Z",
      comment: "",
      donePercentage: 25,
      rating: 3,
      jobFunction: "accounting"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bfee468ffb7ab00363b9196",
      date: "2018-11-28T18:54:32.280Z",
      comment: "",
      donePercentage: 25,
      rating: 3,
      jobFunction: "accounting"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bfee3d775d2b5001cf4d539",
      date: "2018-11-28T18:52:07.807Z",
      comment: "",
      donePercentage: 0,
      rating: 1,
      jobFunction: "accounting"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bfee476ffb7ab00363b9199",
      date: "2018-11-28T18:54:46.563Z",
      comment: "",
      donePercentage: 0,
      rating: 1,
      jobFunction: "accounting"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5baa0e19fc9ac301159384b9",
      date: "2018-09-25T10:29:45.412Z"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5baa0e30fc9ac301159384bb",
      date: "2018-09-25T10:30:08.685Z"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5baa0e58fc9ac301159384bd",
      date: "2018-09-25T10:30:48.914Z"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5baa0facfc9ac301159384bf",
      date: "2018-09-25T10:36:28.157Z"
    },
    {
      action: "5b967031030fd9002244d991",
      category: "leadership",
      _id: "5baaa922cfcbf0001cfc7b79",
      date: "2018-09-25T21:31:14.640Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bbe354aaacbc1001fa797b3",
      date: "2018-10-10T17:22:18.747Z",
      comment: "",
      donePercentage: 100,
      rating: 5
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5bc4993d4bd7b20022bf127b",
      date: "2018-10-15T13:42:21.150Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5bc499b74bd7b20022bf127e",
      date: "2018-10-15T13:44:23.699Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bc499d64bd7b20022bf1281",
      date: "2018-10-15T13:44:54.558Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bc499f54bd7b20022bf1284",
      date: "2018-10-15T13:45:25.831Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bc49a064bd7b20022bf1287",
      date: "2018-10-15T13:45:42.433Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bc49a794bd7b20022bf128a",
      date: "2018-10-15T13:47:37.919Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bc49a8f4bd7b20022bf128d",
      date: "2018-10-15T13:47:59.156Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bc49ab54bd7b20022bf1290",
      date: "2018-10-15T13:48:37.015Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bc49aea4bd7b20022bf1293",
      date: "2018-10-15T13:49:30.110Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5bc49b354bd7b20022bf1296",
      date: "2018-10-15T13:50:45.075Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bc49edbb16fb200a0af14fe",
      date: "2018-10-15T14:06:19.655Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bc49fe5b16fb200a0af1501",
      date: "2018-10-15T14:10:45.818Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bc4a118b16fb200a0af1504",
      date: "2018-10-15T14:15:52.429Z",
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5bc4a143b16fb200a0af1506",
      date: "2018-10-15T14:16:35.468Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5bc4a21192063400adc73d05",
      date: "2018-10-15T14:20:01.313Z",
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5bc4a23f92063400adc73d07",
      date: "2018-10-15T14:20:47.426Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bc4a26992063400adc73d0a",
      date: "2018-10-15T14:21:29.409Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d99e",
      category: "leadership",
      _id: "5bc4a27892063400adc73d0d",
      date: "2018-10-15T14:21:44.925Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967032030fd9002244d998",
      category: "leadership",
      _id: "5bc4a2a492063400adc73d10",
      date: "2018-10-15T14:22:28.668Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bc4ad4e92063400adc73d13",
      date: "2018-10-15T15:07:58.683Z",
      jobFunction: "Technologie"
    },
    {
      action: "5b967032030fd9002244d995",
      category: "leadership",
      _id: "5bc4bcbee36e02001cc27606",
      date: "2018-10-15T16:13:50.752Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Technologie"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bc4bcd9e36e02001cc27609",
      date: "2018-10-15T16:14:17.820Z",
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bc4bd2ee36e02001cc2760b",
      date: "2018-10-15T16:15:42.144Z",
      jobFunction: "Technologie"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bc4be50e36e02001cc2760d",
      date: "2018-10-15T16:20:32.321Z",
      jobFunction: "Technologie"
    },
    {
      action: "5b967033030fd9002244d99d",
      category: "leadership",
      _id: "5bd5f5ba86f0e8001c6a5ce6",
      date: "2018-10-28T17:45:30.095Z",
      comment: "Nice one",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967034030fd9002244d9a6",
      category: "proactivity",
      _id: "5bd5f69986f0e8001c6a5ce9",
      date: "2018-10-28T17:49:13.292Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "leadership",
      _id: "5bd5f7e686f0e8001c6a5cec",
      date: "2018-10-28T17:54:46.650Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967031030fd9002244d994",
      category: "leadership",
      _id: "5bd6149cf62523001d7e46a7",
      date: "2018-10-28T19:57:16.558Z",
      comment: "Test!",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bd61763ccc831002a8fa9f7",
      date: "2018-10-28T20:09:07.674Z",
      comment: "Test",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5bd6197cc9971a0037b81f41",
      date: "2018-10-28T20:18:04.050Z",
      comment: "Retest",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bd61a63f61dd600599bd5c8",
      date: "2018-10-28T20:21:55.434Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967031030fd9002244d993",
      category: "leadership",
      _id: "5bd61c28f61dd600599bd5cb",
      date: "2018-10-28T20:29:28.874Z",
      comment: "Final test",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Opérations"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bd75c03635bd400fc2af136",
      date: "2018-10-29T19:14:11.328Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "Finance"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bedfb40a4c8c0001c362fcf",
      date: "2018-11-15T23:03:28.278Z",
      comment: "",
      donePercentage: 100,
      rating: 5,
      jobFunction: "legal"
    },
    {
      action: "5b967034030fd9002244d9a4",
      category: "publicSpeaking",
      _id: "5bfeac6b386ddb008e33baaf",
      date: "2018-11-28T14:55:39.220Z",
      comment: "Nice one",
      donePercentage: 100,
      rating: 5,
      jobFunction: "human resources"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5be028094647af001c05762a",
      date: "2018-11-05T11:22:49.484Z",
      comment: "",
      donePercentage: 100,
      rating: 4,
      jobFunction: "information technology"
    },
    {
      action: "5b967033030fd9002244d99c",
      category: "leadership",
      _id: "5bfea89b5ac159005abe6184",
      date: "2018-11-28T14:39:23.890Z",
      jobFunction: "human resources"
    },
    {
      action: "5b967031030fd9002244d992",
      category: "leadership",
      _id: "5bfeabd9350f6000813159cc",
      date: "2018-11-28T14:53:13.068Z",
      comment: "Oke",
      donePercentage: 25,
      rating: 5,
      jobFunction: "human resources"
    },
    {
      action: "5b967032030fd9002244d996",
      category: "leadership",
      _id: "5c05760bd046fa00a38a5e7d",
      date: "2018-12-03T18:29:31.360Z",
      comment: 'Il a cliqué sur je "je ne peux pas le faire"',
      donePercentage: 0,
      rating: 5,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a2",
      category: "teamCohesion",
      _id: "5bfea8df5ac159005abe6189",
      date: "2018-11-28T14:40:31.405Z",
      comment: "Tres bin ca",
      donePercentage: 75,
      rating: 4,
      jobFunction: "human resources"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5c02c4f2144b00005d610f35",
      date: "2018-12-01T17:29:22.647Z",
      comment: "Superbe",
      donePercentage: 75,
      rating: 4,
      jobFunction: "legal"
    },
    {
      action: "5b967034030fd9002244d9a3",
      category: "teamCohesion",
      _id: "5c057627d046fa00a38a5e80",
      date: "2018-12-03T18:29:59.576Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d99e",
      category: "leadership",
      _id: "5c0582d5d046fa00a38a5e83",
      date: "2018-12-03T19:24:05.660Z",
      comment: "Nice",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d9a0",
      category: "resilience",
      _id: "5c07fb23cdf88a001c7bc293",
      date: "2018-12-05T16:21:55.856Z",
      comment: "Nice one",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967033030fd9002244d99f",
      category: "leadership",
      _id: "5c09720ea3461c002244d1f6",
      date: "2018-12-06T19:01:34.732Z",
      comment: "Bien",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967030030fd9002244d990",
      category: "proactivity",
      _id: "5c0972b2a3461c002244d1fb",
      date: "2018-12-06T19:04:18.638Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    },
    {
      action: "5b967034030fd9002244d9a5",
      category: "proactivity",
      _id: "5bfea8b15ac159005abe6186",
      date: "2018-11-28T14:39:45.748Z",
      comment: "Pas pu me faire",
      donePercentage: 0,
      rating: 1,
      jobFunction: "human resources"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5bfead6f4cc434009b9cd7f3",
      date: "2018-11-28T14:59:59.958Z",
      jobFunction: "human resources"
    },
    {
      action: "5b967033030fd9002244d9a1",
      category: "resilience",
      _id: "5c07efcbcdf88a001c7bc290",
      date: "2018-12-05T15:33:31.584Z",
      comment: "Top",
      donePercentage: 75,
      rating: 4,
      jobFunction: "marketing"
    }
  ]
};
